import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../services/helpers.js';
import DelayedRedirect from '../../../utils/DelayedRedirect';
import { Transition } from '../../../utils/ModalHelpers';
import { SelectTheme } from '../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import CheckIcon from '@material-ui/icons/Check';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import ModifiedByInfo from "./../../Common/Footers/ModifiedByInfo";
import appFetch from '../../../api/appFetch.js';
import { ActiveInternalChatGroupsUrl, DossierStacksWithIsSettingsTrueUrl, EventTaskWorkflowsOutletsAndBrandsUrl, EventTaskWorkflowsTriggersAndConditionsUrl, EventTaskWorkflowsUrl, EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsUrl, EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsWithIsTextFalseUrl, EventTaskWorkflowsWithConditionsAndTextsWithIdUrl, EventTaskWorkflowsWithIdUrl, OutletUsersNotDeletedUrl } from '../../../constants/apiUrls.js';
import EnhancedDropdownComponent from '../../Common/Dropdowns/EnhancedDropdownComponent.js';
import MultiBrandsDropdown from '../../Common/Dropdowns/MultiBrandsDropdown.js';
import MultiOutletsDropdown from '../../Common/Dropdowns/MultiOutletsDropdown.js';
import LanguageDropdown from '../../Common/Dropdowns/LanguageDropdown.js';
import TeamsDropdown from '../../Common/Dropdowns/TeamsDropdown.js';
import OutletUsersDropdown from '../../Common/Dropdowns/OutletUsersDropdown.js';
import { LanguagesWithLanguageCode } from '../../../utils/constants.js';

// If you find a better solution, go for it
const NULL_OPTION_VALUE_WORKAROUND = "SPECIAL TEXT TO IDENTIFY OPTIONS WITH NULL VALUE"

const ADD_TO_STACK = 40;
const REMOVE_FROM_STACK = 41;
const isStackRecipientType = (sendTo) => sendTo == ADD_TO_STACK || sendTo == REMOVE_FROM_STACK;

export default class TaskWorkflowCreation extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      taskWorkflowId:
        this.props.taskWorkflowId != undefined ? this.props.taskWorkflowId : 0,

      loading: true,
      redirect: null,
      redirectToOutletPage: this.props.redirectToOutletPage ?? false,
      open: true,
      TaskWorkflowWasCreated: false,
      showAddLanguage: false,
      showAddCondition: false,

      description: "",
      outletIds: this.props.outletId > 0 ? [this.props.outletId] : [],
      teamId: 0,
      brandIds: [],
      initialScope: null,
      isActive: true,
      hasOneTask: false,
      expiryPeriod: "",

      triggeredByOtherWorkflow: false,

      triggers: [],
      triggerCode: 0,
      oldValue: null,
      newValue: null,

      taskTexts: [],
      language: this.getFirstUnusedLanguages([]),
      languageDescription: '',
      hasUsedGroupName: false,

      conditions: [],
      additionalConditions: [],
      conditionCode: null,
      conditionValue: 0,

      sendTo: 99,
      sendToDossierOwnerFallback: 0,
      sendToOutletUser: 0,
      userGroups: [],
      sendToUserGroup: 0,

      stacks: [],
      stackId: 0,

      workflows: [],
      workflowId: 0,

      modifiedOn: "",
      modifiedByName: "",
      modifiedByAvatar: "",

      textToBeAdded: [],
      conditionToBeAdded: [],

      textToBeDeleted: [],
      conditionToBeDeleted: [],

      triggerValueLessThan100: false,
    };
  }

  async componentDidMount() {
    try {
      const fetches = [
        this.getTriggersAndConditions(),
        this.getUserGroups(),
        this.getWorkflows(),
        this.getStacks(),
      ];

      if (this.state.taskWorkflowId != 0) {
        fetches.push(this.getEventTaskWorkflow());
      }

      await Promise.all(fetches);
    } finally {
      this.setState({ loading: false });
    }
  }

  getFirstUnusedLanguages = (taskTexts) => {
    const unused = LanguagesWithLanguageCode.filter(l => !taskTexts.find(tt => tt.language === l.code));
    return unused.length > 0 ? unused[0].code : '';
  }

  getEventTaskWorkflow() {
    const { taskWorkflowId } = this.state;

    return appFetch({
      url: EventTaskWorkflowsWithIdUrl(taskWorkflowId),
      onSuccess: (result) => {
        const additionalConditions = [];

        result.conditions.forEach(function (condition) {
          additionalConditions.push({
            id: condition.id,
            code: condition.code,
            codeDescription: condition.codeDescription,
            applicationValue: condition.actualValue,
            applicationValueDescription: condition.actualValueDescription,
          });
        });

        const taskTexts = [];
        var usedGroupName = false;
        result.texts.forEach(function (text) {
          if (text.text.includes("#GroupName#")) usedGroupName = true;
          taskTexts.push({
            id: text.id,
            language: text.language,
            languageDescription: text.text,
          });
        });
        
        const outlets = result.outlets ?? [];
        const outletIds = outlets.map((outlet) => outlet.id);
        const teamId = outlets.length === 1 ? outlets[0].teamId ?? 0 : 0;
        const brandIds = result.brands ?? [];

        this.setState({
          description: result.description,

          outletIds: outletIds,
          teamId: teamId,
          brandIds: brandIds,
          initialScope: { outletIds, teamId, brandIds },

          isActive: result.isActive,
          hasOneTask: result.hasOneTask,
          expiryPeriod: result.expiryPeriod,

          triggeredByOtherWorkflow: result.trigger.code != null ? false : true,

          triggerCode: result.trigger.code != null ? result.trigger.code : 0,
          triggerValueLessThan100: result.trigger.code != null && result.trigger.code < "100",
          oldValue: result.trigger.oldValue ?? null,
          newValue: result.trigger.newValue ?? null,

          taskTexts: taskTexts,
          language: this.getFirstUnusedLanguages(taskTexts),
          additionalConditions: additionalConditions,

          hasUsedGroupName: usedGroupName,
          sendTo: result.recipient.type,
          sendToDossierOwnerFallback:
            result.recipient.type == 10 ? (result.fallbackRecipientId === null ? 0 : result.fallbackRecipientId) : 0,
          sendToOutletUser:
            result.recipient.type == 20 ? result.recipient.id : 0,
          sendToUserGroup:
            result.recipient.type == 30 ? result.recipient.id : 0,
          stackId:
            isStackRecipientType(result.recipient.type) ? result.recipient.id : 0,

          workflowId: result.nextWorkflowId != null ? result.nextWorkflowId : 0,

          modifiedOn: result.modifiedOn,
          modifiedByName: result.modifiedByName,
          modifiedByAvatar: result.modifiedByAvatar,
        });
      },
    });
  }

  getTriggersAndConditions() {
    return appFetch({
      url: EventTaskWorkflowsTriggersAndConditionsUrl(),
      onSuccess: (result) => {
        const triggersData = [];

        result.triggers.forEach(function (rowData) {
          const selectionValuesData = [];

          rowData.sectionValues.forEach(function (selectionValue) {
            selectionValuesData.push({
              applicationValue: selectionValue.applicationValue,
              applicationValueDescription:
                selectionValue.applicationValueDescription,
            });
          });

          triggersData.push({
            code: rowData.code,
            codeDescription: rowData.codeDescription,
            selectionValues: selectionValuesData,
          });
        });

        const conditionsData = [];
        result.conditions.forEach(function (rowData) {
          const conditionSelectionValuesData = [];

          rowData.sectionValues.forEach(function (selectionValue) {
            conditionSelectionValuesData.push({
              applicationValue: selectionValue.applicationValue,
              applicationValueDescription:
                selectionValue.applicationValueDescription,
            });
          });

          conditionsData.push({
            code: rowData.code,
            codeDescription: rowData.codeDescription,
            selectionValues: conditionSelectionValuesData,
          });
        });

        this.setState({
          triggers: triggersData,
          conditions: conditionsData,
        });
      },
    });
  }

  getUserGroups() {
    return appFetch({
      url: ActiveInternalChatGroupsUrl(),
      onSuccess: (result) => {
        const userGroups = [];

        result.forEach(function (rowData) {
          userGroups.push({
            id: rowData.id,
            description: rowData.description,
          });
        });

        this.setState({
          userGroups: userGroups,
        });
      },
    });
  }

  getWorkflows() {
    return appFetch({
      url: EventTaskWorkflowsUrl(),
      onSuccess: (result) => {
        const workflows = [];

        result.forEach(function (rowData) {
          workflows.push({
            id: rowData.id,
            description: rowData.description,
            isTriggeredByOtherWorkflow: rowData.isTriggeredByOtherWorkflow,
          });
        });

        this.setState({
          workflows: workflows,
        });
      },
    });
  }

  getStacks() {
    return appFetch({
      url: DossierStacksWithIsSettingsTrueUrl(),
      onSuccess: (result) => {
        this.setState({
          stacks: result.map((rowData) => ({ id: rowData.id, description: rowData.description })),
        });
      },
    });
  }

  handleClose = () => {
    this.setState({ open: false, redirect: "/taskworkflows" });
  };

  handleChange = (e) => {
    if (e.target.name === "description") {
      if (
        !(
          e.target.value.length > 0 &&
          e.target.value.replace(/\s/g, "").length === 0
        )
      )
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
      return;
    }

    if (e.target.name === "languageDescription") {
      if (
        !(
          e.target.value.length > 0 &&
          e.target.value.replace(/\s/g, "").length === 0
        )
      )
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
      return;
    }

    if (e.target.name === "expiryPeriod") {
      if (e.target.value === "")
        this.setState({ [e.target.name]: "" });
      else if (/^\d+$/.test(e.target.value))
        this.setState({ [e.target.name]: parseInt(e.target.value) });
      return;
    }

    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeOutlets = (outletIds) => {
    // The API rejects a team when more than one outlet is linked, and a team only
    // belongs to a single outlet - so any selection other than exactly one clears it.
    this.setState((prev) => ({
      outletIds,
      teamId: outletIds.length === 1 && outletIds[0] === prev.outletIds[0] ? prev.teamId : 0,
    }));
  };

  handleChangeBrands = (brandIds) => {
    this.setState({ brandIds });
  };

  handleChangeTeam = (e) => {
    this.setState({ teamId: e.target.value });
  };

  handleChangeCheckBox = (e) => {
    if (e.target.name == "triggeredByOtherWorkflow" && e.target.checked) {
      this.setState({ triggerCode: 0, oldValue: null, newValue: null });
    }
    this.setState({ [e.target.name]: e.target.checked });
  };

  handleChangeTrigger = e => {
    this.setState({ triggerCode: e.target.value, triggerValueLessThan100: e.target.value < "100", additionalConditions: [], newValue: null, oldValue: null });
  };

  handleChangeOldValue = e => {
    this.setState({ oldValue: e.target.value });
  };

  handleChangeNewValue = e => {
    this.setState({ newValue: e.target.value });
  };

  handleChangeWorkflow = (e) => {
    this.setState({ workflowId: e.target.value });
  };

  toggleAddLanguage = () => {
    this.setState({ showAddLanguage: true });
  }

  saveLanguage() {
    const {
      taskWorkflowId,
      language,
      languageDescription,
      taskTexts,
      hasUsedGroupName,
      textToBeAdded,
    } = this.state;
    if (
      language === "" ||
      languageDescription === "" ||
      languageDescription === null ||
      languageDescription === undefined
    ) {
      return;
    }

    if (!hasUsedGroupName && languageDescription.includes("#GroupName#"))
      this.setState({ hasUsedGroupName: true });

    if (taskWorkflowId !== 0) {
      var id = Math.floor(Math.random() * 10000);
      taskTexts.push({ id: id, language, languageDescription });
      textToBeAdded.push({ id: id, language: language, text: languageDescription });
      this.setState({ showAddLanguage: false, language: this.getFirstUnusedLanguages(taskTexts), languageDescription: null });

    }
    else {
      taskTexts.push({ id: Math.floor(Math.random() * 10000), language, languageDescription });
      this.setState({ taskTexts, showAddLanguage: false, language: this.getFirstUnusedLanguages(taskTexts), languageDescription: null });
    }
  }

  closeAddLanguage() {
    this.setState({ showAddLanguage: false, languageDescription: null });
  }

  removeLanguage = (taskTextId) => {
    const {
      taskWorkflowId,
      taskTexts,
      hasUsedGroupName,
      textToBeAdded,
      textToBeDeleted,
    } = this.state;

    const index = taskTexts.findIndex((i) => {
      return i.id === taskTextId;
    });

    if (taskWorkflowId !== 0) {
      var text = textToBeAdded.find((x) => x.id === taskTextId);
      if (text === undefined || text === null) {
        textToBeDeleted.push(taskTextId);
      } else {
        const indexTextToBeAdded = textToBeAdded.findIndex((i) => {
          return i.id === taskTextId;
        });

        textToBeAdded.splice(indexTextToBeAdded, 1);
        this.setState({ textToBeAdded });
      }
    }

    taskTexts.splice(index, 1);

    var hasGroupNameTextIndex = taskTexts.findIndex((i) => {
      return i.languageDescription.includes("#GroupName#");
    });

    if (hasUsedGroupName && hasGroupNameTextIndex === -1) {
      this.setState({ hasUsedGroupName: false });
    }

    this.setState({ taskTexts });
  };

  toggleAddCondition() {
    var toggleAddCondition = this.state.showAddCondition;
    this.setState({ showAddCondition: !toggleAddCondition, conditionCode: 0 });
  }

  saveCondition() {
    const {
      taskWorkflowId,
      conditions,
      conditionCode,
      conditionValue,
      additionalConditions,
      conditionToBeAdded,
    } = this.state;

    if (conditionCode === "0") {
      return;
    }

    const conditionIndex = conditions.findIndex((i) => {
      return i.code === parseInt(conditionCode);
    });
    if (conditionIndex == -1) return;

    var condition = conditions[conditionIndex];

    let selectionValue = undefined;
    if (conditionValue != null && conditionValue.trim().length > 0) {
      const valueIndex = condition.selectionValues.findIndex((i) => {
        return i.applicationValue === conditionValue;
      });
      selectionValue = condition.selectionValues[valueIndex];
    }

    if (taskWorkflowId != 0) {
      var id = Math.floor(Math.random() * 10000);

      additionalConditions.push({
        id: id,
        code: condition.code,
        codeDescription: condition.codeDescription,
        applicationValue: selectionValue?.applicationValue,
        applicationValueDescription:
          selectionValue?.applicationValueDescription,
      });
      conditionToBeAdded.push({
        id: id,
        code: conditionCode,
        actualValue:
          conditionValue == NULL_OPTION_VALUE_WORKAROUND
            ? null
            : conditionValue,
      });
      this.setState({ showAddCondition: false });
    } else {
      additionalConditions.push({
        id: Math.floor(Math.random() * 10000),
        code: condition.code,
        codeDescription: condition.codeDescription,
        applicationValue: selectionValue?.applicationValue,
        applicationValueDescription:
          selectionValue?.applicationValueDescription,
      });

      if (conditionCode != null && conditionValue != null) {
        this.setState({
          additionalConditions,
          showAddCondition: false,
          conditionCode: null,
          conditionValue: null,
        });
      }
    }
  }

  closeAddCondition() {
    this.setState({
      showAddCondition: false,
      conditionCode: null,
      conditionValue: null,
    });
  }

  removeCondition = (conditionId) => {
    const {
      taskWorkflowId,
      additionalConditions,
      conditionToBeDeleted,
      conditionToBeAdded,
    } = this.state;

    const index = additionalConditions.findIndex((i) => {
      return i.id === conditionId;
    });

    if (taskWorkflowId !== 0) {
      var condition = conditionToBeAdded.find((x) => x.id === conditionId);
      if (condition === undefined || condition === null) {
        conditionToBeDeleted.push(conditionId);
      } else {
        const indexConditionToBeAdded = conditionToBeAdded.findIndex((i) => {
          return i.id === conditionId;
        });
        conditionToBeAdded.splice(indexConditionToBeAdded, 1);
        this.setState({ conditionToBeAdded: conditionToBeAdded });
      }
    }

    additionalConditions.splice(index, 1);

    this.setState({ additionalConditions });
  };

  handleSendTo(sendTo) {
    if (sendTo !== undefined) {
      this.setState({ sendTo: parseInt(sendTo) });
      switch (sendTo) {
        case 20:
          this.setState({ sendToUserGroup: 0 });
          break;
        case 30:
          this.setState({ sendToOutletUser: 0 });
          break;
        default:
          this.setState({ sendToOutletUser: 0, sendToUserGroup: 0 });
          break;
      }
    }
  }

  handleChangeAction = (isStackAction) => {
    if (isStackAction === isStackRecipientType(this.state.sendTo)) return;

    this.setState({
      sendTo: isStackAction ? ADD_TO_STACK : 99,
      sendToDossierOwnerFallback: 0,
      sendToOutletUser: 0,
      sendToUserGroup: 0,
      stackId: 0,
    });
  };

  handleSubmit = () => {
    const { taskWorkflowId } = this.state;
    if (taskWorkflowId === 0) {
      this.saveNewTaskWorkflow();
    } else {
      this.saveEditedTaskWorkflow();
    }
  };

  saveNewTaskWorkflow = () => {
    this.setState({ loading: true });

    const { resources } = this.props;
    const {
      description,
      sendTo,
      sendToOutletUser,
      sendToUserGroup,
      sendToDossierOwnerFallback,
      stackId,
      isActive,
      hasOneTask,
      workflowId,
      triggerCode,
      oldValue,
      newValue,
      expiryPeriod,
      taskTexts,
      additionalConditions,
      textToBeAdded,
    } = this.state;

    var recipientId = null;
    var fallbackRecipientId = null;
    const isStackAction = isStackRecipientType(sendTo);

    switch (sendTo) {
      case 10:
        fallbackRecipientId = parseInt(sendToDossierOwnerFallback);
        break;
      case 20:
        recipientId = parseInt(sendToOutletUser);
        break;
      case 30:
        recipientId = parseInt(sendToUserGroup);
        break;
      case ADD_TO_STACK:
      case REMOVE_FROM_STACK:
        recipientId = parseInt(stackId);
        break;
      default:
        break;
    }

    var texts = [];
    taskTexts.forEach(function (rowData) {
      texts.push({
        language: rowData.language,
        text: rowData.languageDescription,
      });
    });

    var conditions = [];
    additionalConditions.forEach(function (rowData) {
      conditions.push({
        code: parseInt(rowData.code),
        actualValue: rowData.applicationValue,
      });
    });

    var json = JSON.stringify({
      description: description,
      recipientType: sendTo,
      recipientId: recipientId,
      fallbackRecipientId: fallbackRecipientId === 0 ? null : fallbackRecipientId,
      isActive: isActive,
      hasOneTask: isStackAction ? false : hasOneTask,
      expiryPeriod: isStackAction || expiryPeriod == '' ? null : parseInt(expiryPeriod),
      trigger: triggerCode != 0 ? {
        code: parseInt(triggerCode),
        oldValue: oldValue === NULL_OPTION_VALUE_WORKAROUND || oldValue === 0 ? null : oldValue,
        newValue: newValue === NULL_OPTION_VALUE_WORKAROUND || newValue === 0 ? null : newValue
      } : null,
      texts: texts.length == 0 ? null : texts,
      conditions: conditions.length == 0 ? null : conditions,
      nextWorkflowId: workflowId == 0 ? null : parseInt(workflowId),
    });

    appFetch({
      url: EventTaskWorkflowsUrl(),
      method: "POST",
      body: json,
      onSuccess: async (response) => {
        const { outletIds, brandIds } = this.state;
        if (outletIds.length > 0 || brandIds.length > 0) {
          await this.saveOutletsAndBrands(response.id);
        }

        DisplayMessage(resources["NewWorkflowWasSaved"], "success");
        this.setState({
          TaskWorkflowWasCreated: true,
          redirect: "/taskworkflows",
        });
      },
      onError: (response) => {
        for (var i = 0; i < response.errors.length; i++) {
          DisplayMessage(response.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ loading: false });
      },
    });
  };

  saveOutletsAndBrands = (taskWorkflowId) => {
    const { outletIds, teamId, brandIds } = this.state;

    return appFetch({
      url: EventTaskWorkflowsOutletsAndBrandsUrl(taskWorkflowId),
      method: "PUT",
      body: JSON.stringify({
        outlets: outletIds.map((outletId) => ({
          outletId: outletId,
          teamId: outletIds.length === 1 && teamId > 0 ? parseInt(teamId) : null,
        })),
        brandIds: brandIds,
      }),
      onError: (response) => {
        for (var i = 0; i < response.errors.length; i++) {
          DisplayMessage(response.errors[i], "error");
        }
      },
    });
  };

  hasScopeChanged = () => {
    const { outletIds, teamId, brandIds, initialScope } = this.state;
    if (initialScope === null) return false;

    const sameIds = (a, b) => {
      if (a.length !== b.length) return false;
      const sortedB = [...b].sort();
      return [...a].sort().every((x, i) => x === sortedB[i]);
    };

    return teamId !== initialScope.teamId ||
      !sameIds(outletIds, initialScope.outletIds) ||
      !sameIds(brandIds, initialScope.brandIds);
  };

  isFormValid = () => {
    const { description, sendTo, stackId } = this.state
    if (!description || description.trim().length === 0) {
      return false;
    }

    if (isStackRecipientType(sendTo) && !(stackId > 0)) {
      return false;
    }

    return true;
  };

  saveEditedTaskWorkflow = () => {
    const { resources } = this.props;
    const {
      taskWorkflowId,
      description,
      isActive,
      hasOneTask,
      expiryPeriod,
      workflowId,
      sendTo,
      sendToDossierOwnerFallback,
      sendToOutletUser,
      sendToUserGroup,
      stackId,
      triggerCode,
      oldValue,
      newValue,
      textToBeAdded,
      conditionToBeAdded,
      textToBeDeleted,
      conditionToBeDeleted,
    } = this.state;

    var recipientId = null;
    var fallbackRecipientId = null;

    switch (sendTo) {
      case 10:
        fallbackRecipientId = parseInt(sendToDossierOwnerFallback);
        break;
      case 20:
        recipientId = parseInt(sendToOutletUser);
        break;
      case 30:
        recipientId = parseInt(sendToUserGroup);
        break;
      case ADD_TO_STACK:
      case REMOVE_FROM_STACK:
        recipientId = parseInt(stackId);
        break;
      default:
        break;
    }

    var request = {
      description: description,
      recipientType: sendTo,
      recipientId: recipientId,
      fallbackRecipientId: fallbackRecipientId === 0 ? null : fallbackRecipientId,
      isActive: isActive,
      hasOneTask: hasOneTask,
      expiryPeriod: expiryPeriod == "" ? null : parseInt(expiryPeriod),
      nextWorkflowId: workflowId == 0 ? null : parseInt(workflowId),
    };

    if (triggerCode != 0) {
      request.trigger = {
        oldValue: oldValue === NULL_OPTION_VALUE_WORKAROUND || oldValue === 0 ? null : oldValue,
        newValue: newValue === NULL_OPTION_VALUE_WORKAROUND || newValue === 0 ? null : newValue,
      };
    }

    this.setState({ loading: true });

    const performAsyncOperations = async () => {
      this.setState({ loading: true });

      const patchRequest = fetch(EventTaskWorkflowsWithIdUrl(taskWorkflowId), {
        method: "PATCH",
        headers: new Headers({
          "Content-Type": "application/json",
          PublicKey: localStorage.getItem("publicKey"),
          "Authorization-token": localStorage.getItem("authorizationToken"),
        }),
        body: JSON.stringify(request),
      });

      const postConditionsAndTexts = async () => {
        if (textToBeAdded.length > 0 || conditionToBeAdded.length > 0) {
          const json = JSON.stringify({
            texts: textToBeAdded,
            conditions: conditionToBeAdded,
          });

          const response = await fetch(
            EventTaskWorkflowsWithConditionsAndTextsWithIdUrl(taskWorkflowId),
            {
              method: "POST",
              headers: new Headers({
                "Content-Type": "application/json",
                PublicKey: localStorage.getItem("publicKey"),
                "Authorization-token":
                  localStorage.getItem("authorizationToken"),
              }),
              body: json,
            }
          );

          if (!response.ok) {
            const result = await response.json();
            for (let i = 0; i < result.errors.length; i++) {
              DisplayMessage(result.errors[i], "error");
            }
          } else {
            DisplayMessage(resources["TaskTextSaved"], "success");
            DisplayMessage(resources["ConditionSaved"], "success");
          }
        }
      };

      const deleteTexts = async () => {
        if (textToBeDeleted.length > 0) {
          const ids = textToBeDeleted.join(`&id=`);
          const response = await fetch(
            EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsUrl(
              taskWorkflowId,
              ids
            ),
            {
              method: "DELETE",
              headers: new Headers({
                "Content-Type": "application/json",
                PublicKey: localStorage.getItem("publicKey"),
                "Authorization-token":
                  localStorage.getItem("authorizationToken"),
              }),
            }
          );

          if (response.ok) {
            DisplayMessage(resources["TaskTextRemoved"], "success");
          } else {
            const result = await response.json();
            for (let i = 0; i < result.errors.length; i++) {
              DisplayMessage(result.errors[i], "error");
            }
          }
        }
      };

      const deleteConditions = async () => {
        if (conditionToBeDeleted.length > 0) {
          const ids = conditionToBeDeleted.join(`&id=`);
          const response = await fetch(
            EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsWithIsTextFalseUrl(
              taskWorkflowId,
              ids
            ),
            {
              method: "DELETE",
              headers: new Headers({
                "Content-Type": "application/json",
                PublicKey: localStorage.getItem("publicKey"),
                "Authorization-token":
                  localStorage.getItem("authorizationToken"),
              }),
            }
          );

          if (response.ok) {
            DisplayMessage(resources["ConditionRemoved"], "success");
          } else {
            const result = await response.json();
            for (let i = 0; i < result.errors.length; i++) {
              DisplayMessage(result.errors[i], "error");
            }
          }
        }
      };

      try {
        const patchResponse = await patchRequest;
        await Promise.all([deleteTexts(), deleteConditions()]);
        await postConditionsAndTexts();

        if (this.hasScopeChanged()) {
          await this.saveOutletsAndBrands(taskWorkflowId);
        }

        if (patchResponse && !patchResponse.ok) {
          const result = await patchResponse.json();
          for (let i = 0; i < result.errors.length; i++) {
            DisplayMessage(result.errors[i], "error");
          }
          this.setState({
            loading: false,
            textToBeAdded: [],
            conditionToBeAdded: [],
            textToBeDeleted: [],
            conditionToBeDeleted: [],
          });
        } else {
          DisplayMessage(resources["WorkflowWasSaved"], "success");
          this.setState({ loading: false, TaskWorkflowWasCreated: true });
          this.handleClose();
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    };

    performAsyncOperations();
  };

  // The identity's activeBrands is one entry per outlet + brand, so the same brand
  // repeats for every accessible outlet it is active at - dedupe to one option per brand.
  renderBrandOptions = () => {
    const activeBrands = this.props.activeBrands ?? [];
    const brandsById = new Map();

    activeBrands.forEach((x) => {
      if (!brandsById.has(x.brandId)) {
        brandsById.set(x.brandId, { id: x.brandId, description: x.description });
      }
    });

    return [...brandsById.values()];
  }

  renderScopeHint = (text) => {
    return (
      <div className="d-flex pb-3">
        <div className="col-3"></div>
        <div className="col-6 px-0 text-left d-flex">
          <InfoOutlinedIcon color="disabled"></InfoOutlinedIcon>
          <div className="ml-2 color-grey">{text}</div>
        </div>
      </div>
    );
  }

  renderTriggers = () => {
    if (this.state.triggers === undefined) return [];

    return this.state.triggers.sort((a, b) => (a.codeDescription > b.codeDescription) ? 1 : -1)
      .map(x => ({ key: x.code, name: x.codeDescription }));
  }

  renderOldValues = () => {
    var trigger = this.state.triggers.find(x => x.code == this.state.triggerCode);
    if (!trigger) return [];

    return trigger.selectionValues.sort((a, b) => (a.applicationValueDescription > b.applicationValueDescription) ? 1 : -1)
      .map(x => ({ key: x.applicationValue ?? NULL_OPTION_VALUE_WORKAROUND, name: x.applicationValueDescription }));
  }

  renderNewValues = () => {
    var trigger = this.state.triggers.find(x => x.code == this.state.triggerCode);
    if (!trigger) return [];

    return trigger.selectionValues.filter(x => (x.applicationValue ?? NULL_OPTION_VALUE_WORKAROUND) != this.state.oldValue)
      .sort((a, b) => (a.applicationValueDescription > b.applicationValueDescription) ? 1 : -1)
      .map(x => ({ key: x.applicationValue ?? NULL_OPTION_VALUE_WORKAROUND, name: x.applicationValueDescription }));
  }

  renderTaskTexts() {
    var taskTexts = this.state.taskTexts.map((x) => (
      <div key={x.id} className="d-flex">
        <div className="col-3"></div>
        <div className="col-6 d-flex text-left px-0">
          <div className="col-4 px-0">{x.language}</div>
          <div className="col-7 px-0">{x.languageDescription}</div>
          <div className="col-1">
            <IconButton onClick={() => this.removeLanguage(x.id)} size="small">
              <DeleteIcon style={{ color: "#C4455B" }} />
            </IconButton>
          </div>
        </div>
      </div>
    ));
    return taskTexts;
  }

  renderAddLanguage() {
    const { resources } = this.props;
    const { showAddLanguage, language, languageDescription, taskTexts } =
      this.state;

    if (showAddLanguage) {
      return (
        <div>
          <Form.Group className="pt-3 d-flex">
            <ThemeProvider theme={SelectTheme}>
              <div className="col-3"></div>
              <LanguageDropdown
                resources={resources}
                language={language}
                onLanguageChange={this.handleChange}
                containerClass="col-2 pr-2 helper-text-red"
                filter={l => !taskTexts.find(tt => tt.language === l.code)}
              />

              <TextField
                className="col-4"
                id="taskworkflow-language-description"
                value={languageDescription}
                label={resources["Description"]}
                variant="outlined"
                name="languageDescription"
                onChange={this.handleChange}
                inputProps={{ maxLength: 100 }}
              />
              <div className="col-2 px-2 text-left">
                <IconButton size="small">
                  <CheckIcon onClick={() => this.saveLanguage()} />
                </IconButton>
                <IconButton size="small">
                  <CloseIcon onClick={() => this.closeAddLanguage()} />
                </IconButton>
              </div>
            </ThemeProvider>
          </Form.Group>
        </div>
      );
    } else {
      return;
    }
  }

  renderAdditionalConditions() {
    var taskTexts = this.state.additionalConditions.map((x) => (
      <div key={x.id} className="d-flex">
        <div className="col-3"></div>
        <div className="col-6 d-flex text-left px-0">
          <div className="col-4 px-0">{x.codeDescription}</div>
          <div className="col-1 px-0">=</div>
          <div className="col-6 px-0">{x.applicationValueDescription}</div>
          <div className="col-1">
            <IconButton onClick={() => this.removeCondition(x.id)} size="small">
              <DeleteIcon style={{ color: "#C4455B" }} />
            </IconButton>
          </div>
        </div>
      </div>
    ));
    return taskTexts;
  }

  renderConditionsDropdown() {
    const { triggerValueLessThan100 } = this.state;
    var conditions = this.state.conditions;
    var additionalConditions = this.state.additionalConditions;

    var conditionsCodes = additionalConditions.map((x) => x.code);
    conditions = conditions.filter(
      (val) => !conditionsCodes.includes(val.code)
    );

    if (triggerValueLessThan100) {
      conditions = conditions.filter((x) => x.code < 100);
    }

    return conditions.map(x => ({ key: x.code, name: x.codeDescription }));
  }

  renderConditionValuesDropdown() {
    var condition = this.state.conditions.find(x => x.code == this.state.conditionCode);
    if (!condition) return [];

    var conditionValues = condition.selectionValues.sort((a, b) => (a.applicationValueDescription > b.applicationValueDescription) ? 1 : -1)

    return conditionValues.map(x => ({ key: x.applicationValue ?? NULL_OPTION_VALUE_WORKAROUND, name: x.applicationValueDescription }));
  }

  renderAddCondition() {
    const { resources } = this.props;
    const { showAddCondition, conditionCode, conditionValue } = this.state;

    if (showAddCondition) {
      return (
        <div>
          <Form.Group className="pt-3 d-flex">
            <ThemeProvider theme={SelectTheme}>
              <div className="col-3"></div>
              <div className="col-3 pr-2 helper-text-red" style={{ padding: 0 }}>
                <EnhancedDropdownComponent
                  id="tasktexts-condition-code"
                  labelText={resources["Condition"]}
                  value={conditionCode}
                  placeholder={resources["DefaultDropdownValue"]}
                  options={this.renderConditionsDropdown()}
                  handleChange={this.handleChange}
                  inputName="conditionCode"
                  addMarginBottom={false}
                />
              </div>

              <div className="col-3 pr-2 helper-text-red" style={{ padding: 0 }}>
                <EnhancedDropdownComponent
                  id="tasktexts-condition-value"
                  labelText={resources["Value"]}
                  value={conditionValue}
                  placeholder={resources["DefaultDropdownValue"]}
                  options={this.renderConditionValuesDropdown()}
                  handleChange={this.handleChange}
                  inputName="conditionValue"
                  addMarginBottom={false}
                />
              </div>

              <div className="col-2 px-2 text-left">
                <IconButton size="small">
                  <CheckIcon onClick={() => this.saveCondition()} />
                </IconButton>
                <IconButton size="small">
                  <CloseIcon onClick={() => this.closeAddCondition()} />
                </IconButton>
              </div>
            </ThemeProvider>
          </Form.Group>
        </div>
      );
    } else {
      return;
    }
  }

  renderUserGroupDropdown() {
    const { userGroups } = this.state;
    var userGroupsOptions = userGroups.sort((a, b) =>
      a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1
    );

    return userGroupsOptions.map(x => ({ key: x.id, name: x.description }));
  }

  renderSentTo() {
    const { resources } = this.props;
    const { sendTo, sendToDossierOwnerFallback, sendToOutletUser, sendToUserGroup, triggerCode } =
      this.state;

    return (
      <Form.Group
        style={{ display: "flex", width: "100%", justifyContent: "left" }}
      >
        <div className="col-3"> </div>
        <div className="col-2 px-0">
          <RadioGroup
            defaultValue={sendTo}
            value={sendTo}
            onClick={(e) => this.handleSendTo(e.target.value)}
          >
            <FormControlLabel
              value={99}
              control={<Radio />}
              label={resources["Everybody"]}
            />
            <FormControlLabel
              value={10}
              control={<Radio />}
              label={resources["DossierOwner"]}
            />
            {triggerCode >= 100 ? (
              <FormControlLabel
                value={11}
                control={<Radio />}
                label={resources["JobAssignee"]}
              />
            ) : (
              ""
            )}
            <FormControlLabel
              value={20}
              control={<Radio />}
              label={resources["User"]}
            />
            <FormControlLabel
              value={30}
              control={<Radio />}
              label={resources["UserGroup"]}
            />
          </RadioGroup>
        </div>
        <div className="col-4">
          <div className="fadeOut">
            <Form.Group className="d-flex">
              <ThemeProvider theme={SelectTheme}>
                <FormControl variant="outlined">
                  <Select></Select>
                </FormControl>
              </ThemeProvider>
            </Form.Group>
          </div>
          <div className={this.state.sendTo == 10 ? "fadeIn" : "fadeOutPartially"}>
            <Form.Group className="d-flex">
              <div className="col-12 helper-text-red" style={{ padding: 0 }}>
                <EnhancedDropdownComponent
                  id="sendTo-dossier-owner-fallback"
                  labelText={resources["Fallback"]}
                  value={sendToDossierOwnerFallback}
                  placeholder={resources["DefaultDropdownValue"]}
                  options={this.renderUserGroupDropdown()}
                  handleChange={this.handleChange}
                  inputName="sendToDossierOwnerFallback"
                  addMarginBottom={false}
                />
              </div>
            </Form.Group>
            </div>
          <div className={this.state.sendTo == 20 ? "fadeIn" : "fadeOutPartially"}>
            <Form.Group className="d-flex">
              <OutletUsersDropdown
                resources={resources}
                outletUser={sendToOutletUser}
                onOutletUserChange={this.handleChange}
                onRequestStart={() => this.setState({ requestInProgress: true })}
                onRequestEnd={() => this.setState({ requestInProgress: false })}
                containerClass="col-12 helper-text-red"
                inputName='sendToOutletUser'
              />
            </Form.Group>
          </div>
          <div className={this.state.sendTo == 30 ? "fadeIn" : "fadeOutPartially"}>
            <Form.Group className="d-flex">
              <div className="col-12 helper-text-red" style={{ padding: 0 }}>
                <EnhancedDropdownComponent
                  id="sendTo-user-group"
                  labelText={resources["UserGroup"]}
                  value={sendToUserGroup}
                  placeholder={resources["DefaultDropdownValue"]}
                  options={this.renderUserGroupDropdown()}
                  handleChange={this.handleChange}
                  inputName="sendToUserGroup"
                  addMarginBottom={false}
                />
              </div>
            </Form.Group>
          </div>
        </div>
      </Form.Group>
    );
  }

  renderWorkflows = () => {
    var workflows = this.state.workflows.sort((a, b) =>
      a.description > b.description ? 1 : -1
    );

    return workflows.filter(x => x.isTriggeredByOtherWorkflow == true)
      .map(x => ({ key: x.id, name: x.description }));
  }

  renderOptionCard = ({ id, selected, disabled, onSelect, icon, title, description }) => {
    return (
      <div
        id={id}
        className={"d-flex justify-content-between text-left " + (description ? "align-items-start" : "align-items-center")}
        style={{
          flex: "1 1 0",
          minWidth: 0,
          padding: description ? 12 : "8px 12px",
          borderRadius: 6,
          border: `1px solid ${selected ? "#53B3EA" : "#E0E0E0"}`,
          backgroundColor: selected ? "rgba(83, 179, 234, 0.12)" : "#FFF",
          cursor: disabled ? "default" : "pointer",
        }}
        onClick={disabled ? undefined : onSelect}
      >
        <div style={{ minWidth: 0, overflowWrap: "anywhere" }}>
          {icon}
          <div className={description ? "font-weight-bold" : ""}>{title}</div>
          {description && <div className="color-grey">{description}</div>}
        </div>
        <Radio checked={selected} onChange={disabled ? undefined : onSelect} tabIndex={disabled ? -1 : undefined} color="primary" size="small" className="p-0 ml-2" style={{ flexShrink: 0 }} />
      </div>
    );
  }

  renderAction() {
    const { resources } = this.props;
    const { taskWorkflowId, sendTo } = this.state;
    const isStackAction = isStackRecipientType(sendTo);

    return (
      <div>
        <div className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left">
            <hr className="MuiDivider-root mt-2 mb-3" />
            <h6>{resources["Action"]}</h6>
          </div>
        </div>
        <div className="d-flex pb-2">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left color-grey">
            {resources["WhatHasToHappenOnceTriggerIsFired"]}
          </div>
        </div>
        <Form.Group className={"d-flex mb-2 " + (taskWorkflowId == 0 ? "" : "fadeOutPartially")}>
          <div className="col-3"></div>
          <div className="col-6 px-0 d-flex" style={{ gap: 12 }}>
            {this.renderOptionCard({
              id: "taskworkflow-action-create-task",
              selected: !isStackAction,
              disabled: taskWorkflowId != 0,
              onSelect: () => this.handleChangeAction(false),
              icon: <CheckBoxOutlinedIcon fontSize="small" color={isStackAction ? "disabled" : "primary"} />,
              title: resources["CreateATask"],
              description: resources["CreateATaskDescription"],
            })}
            {this.renderOptionCard({
              id: "taskworkflow-action-stack-movement",
              selected: isStackAction,
              disabled: taskWorkflowId != 0,
              onSelect: () => this.handleChangeAction(true),
              icon: <InboxOutlinedIcon fontSize="small" color={isStackAction ? "primary" : "disabled"} />,
              title: resources["AddOrRemoveFromStack"],
              description: resources["AddOrRemoveFromStackDescription"],
            })}
          </div>
        </Form.Group>
        {isStackAction ? this.renderStackAction() : this.renderTaskAction()}
      </div>
    );
  }

  renderStackAction() {
    const { resources } = this.props;
    const { sendTo, stackId, stacks } = this.state;

    return (
      <div>
        <div className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left">
            <h6>{resources["Movement"]}</h6>
          </div>
        </div>
        <Form.Group className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 px-0 d-flex" style={{ gap: 12 }}>
            {this.renderOptionCard({
              id: "taskworkflow-movement-add-to-stack",
              selected: sendTo == ADD_TO_STACK,
              onSelect: () => this.setState({ sendTo: ADD_TO_STACK }),
              title: resources["AddToStack"],
            })}
            {this.renderOptionCard({
              id: "taskworkflow-movement-remove-from-stack",
              selected: sendTo == REMOVE_FROM_STACK,
              onSelect: () => this.setState({ sendTo: REMOVE_FROM_STACK }),
              title: resources["RemoveFromStack"],
            })}
          </div>
        </Form.Group>
        <Form.Group className="d-flex">
          <div className="col-3"></div>
          <div className={"col-6 " + (stackId > 0 ? "" : "helper-text-red")} style={{ padding: 0 }}>
            <EnhancedDropdownComponent
              id="taskworkflow-stack"
              labelText={resources["SelectStack"]}
              value={stackId}
              placeholder={resources["DefaultDropdownValue"]}
              options={[...stacks]
                .sort((a, b) => (a.description ?? "").toLowerCase() > (b.description ?? "").toLowerCase() ? 1 : -1)
                .map(x => ({ key: x.id, name: x.description }))}
              handleChange={this.handleChange}
              inputName="stackId"
              addMarginBottom={false}
            />
          </div>
        </Form.Group>

        {this.renderTaskTextsSection()}
      </div>
    );
  }

  renderTaskTextsSection() {
    const { resources } = this.props;

    return (
      <div>
        <div className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left">
            <hr className="MuiDivider-root mt-2 mb-3" />
            <h6>{resources["TaskTexts"]}</h6>
          </div>
        </div>
        <div className="d-flex pb-3">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left d-flex">
            <InfoOutlinedIcon color="disabled"></InfoOutlinedIcon>
            <div className="ml-2 color-grey">
              {resources["UseCreatedByAndGroupName"]}
            </div>
          </div>
        </div>
        {this.renderTaskTexts()}
        {this.renderAddLanguage()}
        {this.state.showAddLanguage ? (
          ""
        ) : (
          <div className="d-flex my-2">
            <div className="col-9 px-0 text-right">
              <Button
                id="add-language"
                variant="contained"
                color="primary"
                onClick={this.toggleAddLanguage}
              >
                <i
                  className="fas fa-plus mr-2"
                  title={resources["AddLanguage"]}
                />
                {resources["AddLanguage"]}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderTaskAction() {
    const { resources } = this.props;
    const { hasOneTask, expiryPeriod, hasUsedGroupName, sendToUserGroup } = this.state;

    return (
      <>
        <Form.Group className="mb-2" style={{ display: "flex" }}>
          <div className="col-md-3 "> </div>
          <FormControlLabel
            className="col-md-6 text-right label-mt my-auto p-0"
            control={
              <Checkbox
                id="taskworkflow-has-one-task"
                checked={hasOneTask}
                onChange={this.handleChangeCheckBox}
                name="hasOneTask"
                color="primary"
              />
            }
            label={resources["LimitedToOneActiveTask"]}
          />
          <div className="col-md-4"> </div>
        </Form.Group>

        <Form.Group className="d-flex">
          <div className="col-3"></div>
          <ThemeProvider theme={SelectTheme}>
            <TextField
              className={"col-6"}
              id="taskworkflow-expiryPeriod"
              inputProps={{ inputMode: "numeric", maxLength: 9 }}
              value={expiryPeriod ?? ""}
              name="expiryPeriod"
              type="text"
              placeholder={resources["CloseTaskAutomaticallyAfterXDays"]}
              variant="outlined"
              onChange={this.handleChange}
            />
          </ThemeProvider>
        </Form.Group>

        {this.renderTaskTextsSection()}

        <div>
          <div className="d-flex pb-3">
            <div className="col-3"></div>
            <div className="col-6 px-0 text-left">
              <hr class="MuiDivider-root mt-2 mb-3" />
              <h6>{resources["SendTo"]}</h6>
            </div>
          </div>
          {this.renderSentTo()}

          {hasUsedGroupName && sendToUserGroup == 0 ? (
            <div className="d-flex">
              <div className="col-3"></div>
              <div className="col-6 px-0 text-left d-flex">
                <InfoOutlinedIcon
                  style={{ color: "#C4455B" }}
                ></InfoOutlinedIcon>
                <div className="ml-2 color-red">
                  {resources["YouUsedGroupName"]}
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {!hasUsedGroupName && sendToUserGroup != 0 ? (
            <div className="d-flex">
              <div className="col-3"></div>
              <div className="col-6 px-0 text-left d-flex">
                <InfoOutlinedIcon
                  style={{ color: "#C4455B" }}
                ></InfoOutlinedIcon>
                <div className="ml-2 color-red">
                  {resources["YouHaveNotUsedGroupName"]}
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </>
    );
  }

  renderModifiedByInfo = () => {
    if (this.state.taskWorkflowId > 0) {
      return (
        <ModifiedByInfo
          resources={this.props.resources}
          modifiedByAvatar={this.state.modifiedByAvatar}
          modifiedOn={this.state.modifiedOn}
          modifiedByName={this.state.modifiedByName}
          className="mt-3"
        />
      );
    }
    return;
  };

  renderForm() {
    const handleSubmit = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit();
    };
    const {
      taskWorkflowId,
      description,
      isActive,
      triggeredByOtherWorkflow,
      outletIds,
      brandIds,
    } = this.state;
    const { resources, objectType } = this.props;

    var helperTextDescription =
      description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";

    return (
      <Paper elevation={3} className="p-4 mt-3 mb-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="pt-3 d-flex">
            <div className="col-3"></div>
            <ThemeProvider theme={SelectTheme}>
              <TextField
                className={"col-6 " + helperTextDescription}
                id="taskworkflow-description"
                value={description}
                label={resources["Description"]}
                helperText={resources["InputOfDescriptionIsMandatory"]}
                variant="outlined"
                name="description"
                placeholder={
                  resources["GiveYourWorkflowAMeaningfulDescription"]
                }
                onChange={this.handleChange}
                inputProps={{ maxLength: 250 }}
              />
            </ThemeProvider>
          </Form.Group>

          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <MultiOutletsDropdown
              id="taskworkflow-outlets"
              resources={resources}
              outlets={this.props.accessibleMoboOutlets ?? []}
              outletIds={outletIds}
              onOutletsChange={this.handleChangeOutlets}
              containerClass="col-6 px-0"
            />
          </Form.Group>
          {this.renderScopeHint(resources["LeaveEmptyIfApplicableToAllOutlets"])}

          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <TeamsDropdown
              resources={resources}
              team={this.state.teamId}
              teams={this.props.workshopPlanningTeams}
              onTeamChange={this.handleChangeTeam}
              onRequestStart={() => this.setState({ requestInProgress: true })}
              onRequestEnd={() => this.setState({ requestInProgress: false })}
              disabled={outletIds.length !== 1}
              filter={x => x.teamOutletId == outletIds[0]}
              map={x => ({ key: x.teamId, name: x.teamDescription })}
              containerClass="col-6"
            />
          </Form.Group>
          {this.renderScopeHint(resources["LeaveEmptyIfApplicableToAllTeams"])}

          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <MultiBrandsDropdown
              id="taskworkflow-brands"
              resources={resources}
              brandIds={brandIds}
              brands={this.renderBrandOptions()}
              objectType={objectType}
              onBrandsChange={this.handleChangeBrands}
              onRequestStart={() => this.setState({ requestInProgress: true })}
              onRequestEnd={() => this.setState({ requestInProgress: false })}
              containerClass="col-6"
            />
          </Form.Group>
          {this.renderScopeHint(resources["LeaveEmptyIfApplicableToAllBrands"])}

          <Form.Group style={{ display: "flex" }}>
            <div className="col-md-3 "> </div>
            <FormControlLabel
              className="col-md-6 text-right label-mt my-auto p-0"
              control={
                <Checkbox
                  id="taskworkflow-is-active"
                  checked={isActive}
                  onChange={this.handleChangeCheckBox}
                  name="isActive"
                  color="primary"
                />
              }
              label={resources["IsActive"]}
            />
            <div className="col-md-4"> </div>
          </Form.Group>

          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <div className="col-6 px-0 text-left">
              <hr className="MuiDivider-root mt-2 mb-3" />
              <h6>{resources["Trigger"]}</h6>
            </div>
          </Form.Group>

          <div className={taskWorkflowId == 0 ? "fadeIn" : "fadeOutPartially"}>
            <Form.Group style={{ display: "flex" }}>
              <div className="col-md-3 "> </div>
              <FormControlLabel
                className="col-md-6 text-right label-mt my-auto p-0"
                control={
                  <Checkbox
                    id="taskworkflow-triggeredByOtherWorkflow"
                    checked={triggeredByOtherWorkflow}
                    onChange={this.handleChangeCheckBox}
                    name="triggeredByOtherWorkflow"
                    color="primary"
                  />
                }
                label={resources["TriggeredByOtherWorkflow"]}
              />
              <div className="col-md-4"> </div>
            </Form.Group>
          </div>
        </Form>

        <div
          className={
            triggeredByOtherWorkflow || taskWorkflowId != 0
              ? "fadeOutPartially"
              : "fadeIn"
          }
        >
          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <div className="col-2 text-left px-0">{resources["If"]}</div>
            <div className="col-4 helper-text-red" style={{ padding: 0 }}>
              <EnhancedDropdownComponent
                id="taskworkflow-trigger"
                labelText={resources["Trigger"]}
                value={this.state.triggerCode}
                placeholder={resources["DefaultDropdownValue"]}
                options={this.renderTriggers()}
                handleChange={this.handleChangeTrigger}
                addMarginBottom={false}
              />
            </div>
          </Form.Group>
        </div>

        <div
          className={triggeredByOtherWorkflow ? "fadeOutPartially" : "fadeIn"}
        >
          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <div className="col-2 text-left px-0">{resources["ChangesFrom"]}</div>
            <div className="col-4 helper-text-red" style={{ padding: 0 }}>
              <EnhancedDropdownComponent
                id="taskworkflow-oldvalue"
                labelText={resources["OldValue"]}
                value={this.state.oldValue}
                placeholder={resources["DefaultDropdownValue"]}
                options={this.renderOldValues()}
                handleChange={this.handleChangeOldValue}
                addMarginBottom={false}
              />
            </div>
          </Form.Group>
        </div>

        <div
          className={triggeredByOtherWorkflow ? "fadeOutPartially" : "fadeIn"}
        >
          <Form.Group className="d-flex">
            <div className="col-3"></div>
            <div className="col-2 text-left px-0">{resources["To"]}</div>
            <div className="col-4 helper-text-red" style={{ padding: 0 }}>
              <EnhancedDropdownComponent
                id="taskworkflow-newvalue"
                labelText={resources["NewValue"]}
                value={this.state.newValue}
                placeholder={resources["DefaultDropdownValue"]}
                options={this.renderNewValues()}
                handleChange={this.handleChangeNewValue}
                addMarginBottom={false}
              />
            </div>
          </Form.Group>
        </div>

        <div>
          <div className="d-flex pb-3">
            <div className="col-3"></div>
            <div className="col-6 px-0 text-left">
              <hr className="MuiDivider-root mt-2 mb-3" />
              <h6>{resources["AdditionalConditions"]}</h6>
            </div>
          </div>
          {this.renderAdditionalConditions()}
          {this.renderAddCondition()}
          {this.state.showAddCondition ? (
            ""
          ) : (
            <div className="d-flex my-2">
              <div className="col-9 px-0 text-right">
                <Button
                  id="add-condition"
                  variant="contained"
                  color="primary"
                  onClick={() => this.toggleAddCondition()}
                >
                  <i
                    className="fas fa-plus mr-2"
                    title={resources["AddCondition"]}
                  />
                  {resources["AddCondition"]}
                </Button>
              </div>
            </div>
          )}
        </div>

        {this.renderAction()}

        <div className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left">
            <hr class="MuiDivider-root mt-2 mb-3" />
            <h6>{resources["NextWorkflow"]}</h6>
          </div>
        </div>
        <div className="d-flex pb-3">
          <div className="col-3"></div>
          <div className="col-6 px-0 text-left d-flex">
            <InfoOutlinedIcon color="disabled"></InfoOutlinedIcon>
            <div className="ml-2 color-grey">
              {resources["OptionallySelectWorkflow"]}
            </div>
          </div>
        </div>
        <Form.Group className="d-flex">
          <div className="col-3"></div>
          <div className="col-6 helper-text-red" style={{ padding: 0 }}>
            <EnhancedDropdownComponent
              id="workflow-optional"
              labelText={resources["Workflow"]}
              value={this.state.workflowId}
              placeholder={resources["DefaultDropdownValue"]}
              options={this.renderWorkflows()}
              handleChange={this.handleChangeWorkflow}
              addMarginBottom={false}
            />
          </div>
        </Form.Group>
        {this.renderModifiedByInfo()}
      </Paper>
    );
  }

  renderMain() {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="centered-loader">
          <CircularProgress />
        </div>
      );
    }

    return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
      {this.renderForm()}
    </div>;
  }

  render() {
    const { redirect, redirectToOutletPage, open, TaskWorkflowWasCreated, loading, taskWorkflowId } = this.state;
    const { resources, outletId } = this.props;

    const isSaveButtonDisabled = loading || !this.isFormValid() || redirect;

    return (
      <div>
        {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: TaskWorkflowWasCreated, outletId: redirectToOutletPage ? outletId : 0 } }} delay={250} />}
        <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
          <AppBar className="position-sticky">
            <Toolbar>
              <IconButton
                id="close-add-taskworkflow"
                edge="start"
                color="inherit"
                onClick={this.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ flex: 1 }}>
                {taskWorkflowId === 0
                  ? resources["NewWorkflowTitle"]
                  : resources["EditWorkflowTitle"]}
              </Typography>
              <Button
                id="taskworkflow-save"
                color="inherit"
                disabled={isSaveButtonDisabled}
                onClick={this.handleSubmit}
              >
                {resources["Save"]}
              </Button>
            </Toolbar>
          </AppBar>
          <div className="container">{this.renderMain()}</div>
        </Dialog>
      </div>
    );
  }
}